import M from 'moment';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import RangeFilterComponent from '72cms-ui/components/helpers/RangeFilterComponent';

export default {
    fields: {
        name: {
            component: LinkTitleComponent,
        },
        category: {
            // component: LinkTitleComponent,
            component: {
                template: `<span>{{ _.get(initialValue, 'name', '') }}</span>`,
                props: ['initialValue'],
            },
        },
        available_at: {
            label: 'Published',
            component: {
                template: `<span class="small">{{ initialValue ? __(initialValue, ['date']) : '' }}</span>`,
                props: ['initialValue'],
            },
        }
    },
    filterable: [

    ],
    sortable: ['name', 'available_at'],
    toolbar: ['create'],
    customFilters: [
        {
            name: 'Month',
            component: RangeFilterComponent,
            field: 'created_at',
            options: _.chain(_.range(2015, M().year() + 1)).map(year => {
                return _.range(0, 11).map(month => {
                    const date = M([year, month, 1]);
                    const dateNextMonth = M([year, month, 1]).add(1, 'month');

                    const label = date.format('MMMM YYYY');
                    const range = [date.format('YYYY-MM-DD'), dateNextMonth.format('YYYY-MM-DD')];

                    return { label, range, date };
                })
            })
            .flatten()
            .reverse()
            .filter(({ date }) => date.isSameOrBefore())
            .value(),
        },
        {
            name: 'Category',
            component: CustomFilterComponent,
            key: 'category.id',
            endpoint: '/news_categories/_ref_',
            searchable: false,
        },
    ],
    pagination: true,
    searchable: true,
    hierarchy: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'preview',
            component: 'preview-button',
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.news_posts.js